import { AssetClass } from '@/entities/assets'

import { TRANSACTION_TYPE } from '@/entities/transactions/utils/const'

import { WizardValues } from '../utils/types'
import { createHolding, createMarks, ensureOwnerAccount, ensureTagIds } from '../utils/create'

/**
 * What the property is filed as when the user does not say.
 *
 * The step asks for a type in the property's own words — "house", "apartment",
 * "land" — and leaves it optional, so this is the fallback rather than the
 * answer. Same value the legacy Real Estate wizard files everything under, so
 * the two wizards' output sorts together.
 */
const PROPERTY_TYPE = 'property'

/**
 * One property, held in the account the ownership step named.
 *
 * The simplest of the six: a single holding, and an account only where the user
 * chose to create one.
 */
export const create = async (values: WizardValues): Promise<AssetClass[]> => {
  const tagIds = await ensureTagIds(values.tags)
  const accountId = await ensureOwnerAccount(values)

  const property = await createHolding({
    accountId,
    transactionType: TRANSACTION_TYPE.ADD_POSITION,
    name: values.assetName,
    type: values.assetType || PROPERTY_TYPE,
    currency: values.currency,
    description: values.description,
    amount: values.amount,
    date: values.date,
    tagIds,
  })

  /*
   * After the holding, because a price needs the asset it is a price of. An
   * empty list is the normal case — the valuation step is optional.
   */
  await createMarks(property.id, values.prices)

  return [property]
}
